import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LuggageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"luggage"}/>
}
